import type { z } from 'zod';
import type {
  EmailTemplateSchema,
  UpdateEmailTemplateSchema,
} from './email-template.schema';

export type EmailTemplateDTO = z.infer<typeof EmailTemplateSchema>;

export type UpdateEmailTemplateDTO = z.infer<typeof UpdateEmailTemplateSchema>;

export enum EmailTemplateType {
  INVITE = 'invite',
}

export interface BaseEmailTemplate {
  subject: string;
  bodyText: string;
}
